import { Button, Card, Icon, Text } from "@shopify/polaris"
import { observer } from "mobx-react"
import { XIcon } from "polaris-enhance"
import { useMount } from "react-use"

import APIApp from "@/api/app"
import stores from "@/stores"
const CrollSellModal = () => {
  const { PlanStore } = stores
  useMount(() => {
    if (PlanStore.config?.user_pkg?.show_book_demo) {
      APIApp.report({ event: 2 })
    }
  })
  return (
    PlanStore.config?.user_pkg?.show_book_demo && (
      <div className="fixed inset-0 bg-black/50 z-[99999999] flex items-center justify-center">
        <div className="w-full sm:w-[620px] relative">
          <div className="absolute z-50 top-2 right-2 p-1">
            <Button
              variant="tertiary"
              icon={<Icon source={XIcon} />}
              onClick={async () => {
                PlanStore.config!.user_pkg!.show_book_demo = false
                const res = await APIApp.closeBanner(9)
                if (res.code !== 1000) {
                  PlanStore.config!.user_pkg!.show_book_demo = true
                }
              }}
            />
          </div>
          <Card padding="0">
            <div className="flex">
              <div className="w-[248px] h-[152px] flex-shrink-0 hidden sm:flex">
                <img
                  src="/images/bookdemo.png"
                  className="h-full w-full"
                  alt=""
                />
              </div>
              <div className="p-4 space-y-2">
                <div>
                  <Text as="h2" variant="headingSm">
                    {t("BookADemo")}{" "}
                  </Text>
                </div>
                <Text as="p" variant="bodySm">
                  {t("GetPersonalizedExpertServiceAndSupp")}{" "}
                </Text>
                <Button
                  url="https://calendly.com/channelwill-parcelpanel/parcelpanel"
                  target="_blank"
                  external
                  onClick={async () => {
                    APIApp.report({ event: 1 })
                    // UserInfoStore.setShowBanner("book_demo", 2)
                    // const res = await APIApp.closeBanner(9)
                    // if (res.code !== 1000) {
                    //   UserInfoStore.setShowBanner("book_demo", 1)
                    // }
                  }}
                >
                  {t("BookADemo")}{" "}
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    )
  )
}
export default observer(CrollSellModal)
